/** DO NOT EDIT! **/
/* THIS IS AUTOMATICALLY GENERATED FILE */
/* ng run your-app:generate-icons (see package.json) */
/* eslint-disable @typescript-eslint/naming-convention */
import {TBntIcon as BaseTBntIcon} from '@binotel-frontend/bnt-common-components';

export type TBntIcon =
  | BaseTBntIcon
  | 'od-16-arrow-down'
  | 'od-16-arrow-top'
  | 'od-16-arrow-up-down'
  | 'od-16-check'
  | 'od-16-chevron-down'
  | 'od-16-chevron-first'
  | 'od-16-chevron-last'
  | 'od-16-chevron-left'
  | 'od-16-chevron-right'
  | 'od-16-chevron-up'
  | 'od-16-close'
  | 'od-16-minus'
  | 'od-alert-24'
  | 'od-arrow-left-24'
  | 'od-arrow-top-24'
  | 'od-arrow-up-24'
  | 'od-arrow-up-right-24'
  | 'od-calendar-dates-24'
  | 'od-case-24'
  | 'od-chevron-down-24'
  | 'od-chevron-first-24'
  | 'od-chevron-last-24'
  | 'od-chevron-left-24'
  | 'od-chevron-right-24'
  | 'od-chevron-up-24'
  | 'od-clipboard-text-24'
  | 'od-close-24'
  | 'od-close-small-24'
  | 'od-database-backup-24'
  | 'od-delete-24'
  | 'od-download-24'
  | 'od-exit-24'
  | 'od-eye-24'
  | 'od-eye-crossed-24'
  | 'od-facebook-24'
  | 'od-favorite-24'
  | 'od-favorite-fill-24'
  | 'od-globe-24'
  | 'od-history-24'
  | 'od-info-24'
  | 'od-instagram-24'
  | 'od-list-tree-24'
  | 'od-lock-24'
  | 'od-login-24'
  | 'od-magazine-24'
  | 'od-mail-24'
  | 'od-maximize-24'
  | 'od-menu-24'
  | 'od-minus-24'
  | 'od-notifications-24'
  | 'od-other-24'
  | 'od-paperclip-24'
  | 'od-phone-24'
  | 'od-pin-24'
  | 'od-plus-24'
  | 'od-print-24'
  | 'od-refresh-cw-24'
  | 'od-remove-24'
  | 'od-search-24'
  | 'od-settings-24'
  | 'od-share-24'
  | 'od-sign-24'
  | 'od-square-24'
  | 'od-square-check-big-24'
  | 'od-submenu-24'
  | 'od-support-24'
  | 'od-user-24'
  | 'od-user-star-24'
  | 'od-wallet-24'
  | 'od-zap-24'
  | 'od-40-case'
  | 'od-40-eye'
  | 'od-40-gavel'
  | 'od-40-hand-coins'
  | 'od-40-library'
  | 'od-40-magazine'
  | 'od-40-search-check'
  | 'od-40-search'
  | 'od-40-shield-user'
  | 'od-40-user'
  | 'od-40-zap';

export const consumerIcons: Record<string, string> = {
  'od-16-arrow-down':
    'assets/icons/od-16/arrow-down.svg?v=8f7b798a2145abee6c6a594ac2908cbd',
  'od-16-arrow-top':
    'assets/icons/od-16/arrow-top.svg?v=9300f1c318a53cbd4ba12d00995b3a13',
  'od-16-arrow-up-down':
    'assets/icons/od-16/arrow-up-down.svg?v=3b66206fbbb4676ada6feff3bbe50401',
  'od-16-check':
    'assets/icons/od-16/check.svg?v=98ad7176e29478c39c8d1366a57f3715',
  'od-16-chevron-down':
    'assets/icons/od-16/chevron-down.svg?v=6db1b50feb1164119ce38c683a318db1',
  'od-16-chevron-first':
    'assets/icons/od-16/chevron-first.svg?v=7e9d7c8e888c90aac730e03cea79721f',
  'od-16-chevron-last':
    'assets/icons/od-16/chevron-last.svg?v=845fd8769acdcae68a461e2adebf0317',
  'od-16-chevron-left':
    'assets/icons/od-16/chevron-left.svg?v=7542c740f535d11b416864439e1c55db',
  'od-16-chevron-right':
    'assets/icons/od-16/chevron-right.svg?v=8362c2f214d090381e71b5ad6b1c6352',
  'od-16-chevron-up':
    'assets/icons/od-16/chevron-up.svg?v=0f57e23ac34dda3d22e1d656a86e9f03',
  'od-16-close':
    'assets/icons/od-16/close.svg?v=7680979c367229ae6fb7e5f7095d4a8f',
  'od-16-minus':
    'assets/icons/od-16/minus.svg?v=99d05798a1459100751330b40e5c5b57',
  'od-alert-24':
    'assets/icons/od/alert-24.svg?v=8f6f83b1a6fc1c34a505e46ec619164a',
  'od-arrow-left-24':
    'assets/icons/od/arrow-left-24.svg?v=462fd05007aad9f24d3a3ed9595e9814',
  'od-arrow-top-24':
    'assets/icons/od/arrow-top-24.svg?v=64ec48ce113df3045406067063a41da1',
  'od-arrow-up-24':
    'assets/icons/od/arrow-up-24.svg?v=4842ab6ccf7b01dfa1adb1e701ceb5d0',
  'od-arrow-up-right-24':
    'assets/icons/od/arrow-up-right-24.svg?v=4ac18f05117b3945604401d746b85242',
  'od-calendar-dates-24':
    'assets/icons/od/calendar-dates-24.svg?v=a3a00e70c9418ec07b7485b96e7cd2b9',
  'od-case-24':
    'assets/icons/od/case-24.svg?v=cafd93bcf899e070d81f54fe3618ffbe',
  'od-chevron-down-24':
    'assets/icons/od/chevron-down-24.svg?v=20c12ceec624c220971a3840634b6015',
  'od-chevron-first-24':
    'assets/icons/od/chevron-first-24.svg?v=4896844409bfc2abd5b63844fb35b8ea',
  'od-chevron-last-24':
    'assets/icons/od/chevron-last-24.svg?v=8aee81c6b985cc73b5d011833a337ead',
  'od-chevron-left-24':
    'assets/icons/od/chevron-left-24.svg?v=6f24bb9b0b79269101dbbb5ea41c8c08',
  'od-chevron-right-24':
    'assets/icons/od/chevron-right-24.svg?v=0e245690edb0d2759561bc218cf6218d',
  'od-chevron-up-24':
    'assets/icons/od/chevron-up-24.svg?v=c25a74de35d830bc2036a9736046d63a',
  'od-clipboard-text-24':
    'assets/icons/od/clipboard-text-24.svg?v=e8bceb867e433ab5586ed97cbacb590b',
  'od-close-24':
    'assets/icons/od/close-24.svg?v=48fd8803a14d09d5fe41a66c3bcb08cc',
  'od-close-small-24':
    'assets/icons/od/close-small-24.svg?v=c3153f430cb23d4a0114e87a801748c9',
  'od-database-backup-24':
    'assets/icons/od/database-backup-24.svg?v=5ae0a6cd10bfb36ffca9ae5e14807daf',
  'od-delete-24':
    'assets/icons/od/delete-24.svg?v=5f1212ea49c7c7f22e7cc7400577bcf0',
  'od-download-24':
    'assets/icons/od/download-24.svg?v=8b11425cccacc7abaa35919739dff5c6',
  'od-exit-24':
    'assets/icons/od/exit-24.svg?v=2398be2442586c7b1d8f7dc7fa4232bd',
  'od-eye-24': 'assets/icons/od/eye-24.svg?v=cf621a1ca990532ec381b0a89c1e3580',
  'od-eye-crossed-24':
    'assets/icons/od/eye-crossed-24.svg?v=4df734f2844e929c4ed729f6a324d208',
  'od-facebook-24':
    'assets/icons/od/facebook-24.svg?v=380ba2c9c2fd5f9a458e787d0b543758',
  'od-favorite-24':
    'assets/icons/od/favorite-24.svg?v=4f1ad2bd9b34caa47662fdba1b2840d9',
  'od-favorite-fill-24':
    'assets/icons/od/favorite-fill-24.svg?v=bb20ef0a3afb12cc05e83dab19e99d4d',
  'od-globe-24':
    'assets/icons/od/globe-24.svg?v=e0c3fdcead59fc1c7d05aeda2cfcbe57',
  'od-history-24':
    'assets/icons/od/history-24.svg?v=3fd6674bbbe83d93ab9041d9f8b91e95',
  'od-info-24':
    'assets/icons/od/info-24.svg?v=91c8e1c4697e3949b430451f5a4422aa',
  'od-instagram-24':
    'assets/icons/od/instagram-24.svg?v=1ab18e6be060744dd58b3b0f40fa9149',
  'od-list-tree-24':
    'assets/icons/od/list-tree-24.svg?v=b788bee3e324a50fbe71917ce9cad78f',
  'od-lock-24':
    'assets/icons/od/lock-24.svg?v=cdd5886527bbe4c3065192dbf39f08e2',
  'od-login-24':
    'assets/icons/od/login-24.svg?v=ae9772d45073e0907d5fa75f70e30bd6',
  'od-magazine-24':
    'assets/icons/od/magazine-24.svg?v=b08ec5cbfe2d371bebdb33813bad5be6',
  'od-mail-24':
    'assets/icons/od/mail-24.svg?v=31c6273a7b17df31b1f15bc6b6c6a99c',
  'od-maximize-24':
    'assets/icons/od/maximize-24.svg?v=e1b513dd6ea64f293230c94523af22b3',
  'od-menu-24':
    'assets/icons/od/menu-24.svg?v=15fa8bed016226647e1d9a8d6022ea26',
  'od-minus-24':
    'assets/icons/od/minus-24.svg?v=dbfcf43ab089182d70beccfd110bea6e',
  'od-notifications-24':
    'assets/icons/od/notifications-24.svg?v=7546d3f61245b7c042c69b4f31ad85c1',
  'od-other-24':
    'assets/icons/od/other-24.svg?v=d910ef8b4167632fa7961d4f0bfab845',
  'od-paperclip-24':
    'assets/icons/od/paperclip-24.svg?v=4931bf1914c2781d52ecaef77ba03ab2',
  'od-phone-24':
    'assets/icons/od/phone-24.svg?v=e90d105ad24861d0b570469c7ad1cc81',
  'od-pin-24': 'assets/icons/od/pin-24.svg?v=4dcea2f8b1dc2a026923040db6bd3ecf',
  'od-plus-24':
    'assets/icons/od/plus-24.svg?v=62fd4850f9951a217799a2953c5f31f2',
  'od-print-24':
    'assets/icons/od/print-24.svg?v=3b7cf756728efb287217ccd2ea5fa865',
  'od-refresh-cw-24':
    'assets/icons/od/refresh-cw-24.svg?v=5f69086ffd165297866d756410a4c268',
  'od-remove-24':
    'assets/icons/od/remove-24.svg?v=73d48cf490a20378329230fc92346dbb',
  'od-search-24':
    'assets/icons/od/search-24.svg?v=bcd5b5649f77e3783d5b0685f0acf56f',
  'od-settings-24':
    'assets/icons/od/settings-24.svg?v=d082892ecd0752cee6ea1580e2df3c75',
  'od-share-24':
    'assets/icons/od/share-24.svg?v=2c11ae87a435cacffc85dcf4401adda3',
  'od-sign-24':
    'assets/icons/od/sign-24.svg?v=a0d8266ec88a4c9f023ecc0803eab6fa',
  'od-square-24':
    'assets/icons/od/square-24.svg?v=148b73ed88e74bbf530cc5ffab45cd88',
  'od-square-check-big-24':
    'assets/icons/od/square-check-big-24.svg?v=bd9b6228352bd8cccda797d99bd24511',
  'od-submenu-24':
    'assets/icons/od/submenu-24.svg?v=161a8f49563000ba46ee35084f88a168',
  'od-support-24':
    'assets/icons/od/support-24.svg?v=d61f82117e2f57a9a45aa9ed4a72a302',
  'od-user-24':
    'assets/icons/od/user-24.svg?v=11f34927e95d178e76231fb027197b45',
  'od-user-star-24':
    'assets/icons/od/user-star-24.svg?v=e2f1fa7b99ee37742fd4839c783179df',
  'od-wallet-24':
    'assets/icons/od/wallet-24.svg?v=a7f8ef3136331760a0d672b2af8e7333',
  'od-zap-24': 'assets/icons/od/zap-24.svg?v=f6cb1b56f36d7e72907a16f0490159ff',
  'od-40-case':
    'assets/icons/od-40/case.svg?v=a79651233331c42a242490467e8b2c8c',
  'od-40-eye': 'assets/icons/od-40/eye.svg?v=168ac5f9465988c0a2679ac914896d23',
  'od-40-gavel':
    'assets/icons/od-40/gavel.svg?v=5a83b59e0a85d6c9a0e748a1628dfefb',
  'od-40-hand-coins':
    'assets/icons/od-40/hand-coins.svg?v=f0829be4b867ba70643a0c9569663688',
  'od-40-library':
    'assets/icons/od-40/library.svg?v=2adc2a7b1fc165c3edef891a7e6ac4e7',
  'od-40-magazine':
    'assets/icons/od-40/magazine.svg?v=32f336f2e534f253d94506b919977fc8',
  'od-40-search-check':
    'assets/icons/od-40/search-check.svg?v=5d65d02d0ac9659a7785a572884844cd',
  'od-40-search':
    'assets/icons/od-40/search.svg?v=5f67c56f45b01a55b88afd44c64a4831',
  'od-40-shield-user':
    'assets/icons/od-40/shield-user.svg?v=bac211e7bec3729ed96228bf2bc7fc32',
  'od-40-user':
    'assets/icons/od-40/user.svg?v=4077d96f0cd3e6fa71131d8f30a9f0f5',
  'od-40-zap': 'assets/icons/od-40/zap.svg?v=0b692bea08538cccbc6e66e7755c6117',
};

// METADATA: {"od-16-arrow-down":"8f7b798a2145abee6c6a594ac2908cbd","od-16-arrow-top":"9300f1c318a53cbd4ba12d00995b3a13","od-16-arrow-up-down":"3b66206fbbb4676ada6feff3bbe50401","od-16-check":"98ad7176e29478c39c8d1366a57f3715","od-16-chevron-down":"6db1b50feb1164119ce38c683a318db1","od-16-chevron-first":"7e9d7c8e888c90aac730e03cea79721f","od-16-chevron-last":"845fd8769acdcae68a461e2adebf0317","od-16-chevron-left":"7542c740f535d11b416864439e1c55db","od-16-chevron-right":"8362c2f214d090381e71b5ad6b1c6352","od-16-chevron-up":"0f57e23ac34dda3d22e1d656a86e9f03","od-16-close":"7680979c367229ae6fb7e5f7095d4a8f","od-16-minus":"99d05798a1459100751330b40e5c5b57","od-alert-24":"8f6f83b1a6fc1c34a505e46ec619164a","od-arrow-left-24":"462fd05007aad9f24d3a3ed9595e9814","od-arrow-top-24":"64ec48ce113df3045406067063a41da1","od-arrow-up-24":"4842ab6ccf7b01dfa1adb1e701ceb5d0","od-arrow-up-right-24":"4ac18f05117b3945604401d746b85242","od-calendar-dates-24":"a3a00e70c9418ec07b7485b96e7cd2b9","od-case-24":"cafd93bcf899e070d81f54fe3618ffbe","od-chevron-down-24":"20c12ceec624c220971a3840634b6015","od-chevron-first-24":"4896844409bfc2abd5b63844fb35b8ea","od-chevron-last-24":"8aee81c6b985cc73b5d011833a337ead","od-chevron-left-24":"6f24bb9b0b79269101dbbb5ea41c8c08","od-chevron-right-24":"0e245690edb0d2759561bc218cf6218d","od-chevron-up-24":"c25a74de35d830bc2036a9736046d63a","od-clipboard-text-24":"e8bceb867e433ab5586ed97cbacb590b","od-close-24":"48fd8803a14d09d5fe41a66c3bcb08cc","od-close-small-24":"c3153f430cb23d4a0114e87a801748c9","od-database-backup-24":"5ae0a6cd10bfb36ffca9ae5e14807daf","od-delete-24":"5f1212ea49c7c7f22e7cc7400577bcf0","od-download-24":"8b11425cccacc7abaa35919739dff5c6","od-exit-24":"2398be2442586c7b1d8f7dc7fa4232bd","od-eye-24":"cf621a1ca990532ec381b0a89c1e3580","od-eye-crossed-24":"4df734f2844e929c4ed729f6a324d208","od-facebook-24":"380ba2c9c2fd5f9a458e787d0b543758","od-favorite-24":"4f1ad2bd9b34caa47662fdba1b2840d9","od-favorite-fill-24":"bb20ef0a3afb12cc05e83dab19e99d4d","od-globe-24":"e0c3fdcead59fc1c7d05aeda2cfcbe57","od-history-24":"3fd6674bbbe83d93ab9041d9f8b91e95","od-info-24":"91c8e1c4697e3949b430451f5a4422aa","od-instagram-24":"1ab18e6be060744dd58b3b0f40fa9149","od-list-tree-24":"b788bee3e324a50fbe71917ce9cad78f","od-lock-24":"cdd5886527bbe4c3065192dbf39f08e2","od-login-24":"ae9772d45073e0907d5fa75f70e30bd6","od-magazine-24":"b08ec5cbfe2d371bebdb33813bad5be6","od-mail-24":"31c6273a7b17df31b1f15bc6b6c6a99c","od-maximize-24":"e1b513dd6ea64f293230c94523af22b3","od-menu-24":"15fa8bed016226647e1d9a8d6022ea26","od-minus-24":"dbfcf43ab089182d70beccfd110bea6e","od-notifications-24":"7546d3f61245b7c042c69b4f31ad85c1","od-other-24":"d910ef8b4167632fa7961d4f0bfab845","od-paperclip-24":"4931bf1914c2781d52ecaef77ba03ab2","od-phone-24":"e90d105ad24861d0b570469c7ad1cc81","od-pin-24":"4dcea2f8b1dc2a026923040db6bd3ecf","od-plus-24":"62fd4850f9951a217799a2953c5f31f2","od-print-24":"3b7cf756728efb287217ccd2ea5fa865","od-refresh-cw-24":"5f69086ffd165297866d756410a4c268","od-remove-24":"73d48cf490a20378329230fc92346dbb","od-search-24":"bcd5b5649f77e3783d5b0685f0acf56f","od-settings-24":"d082892ecd0752cee6ea1580e2df3c75","od-share-24":"2c11ae87a435cacffc85dcf4401adda3","od-sign-24":"a0d8266ec88a4c9f023ecc0803eab6fa","od-square-24":"148b73ed88e74bbf530cc5ffab45cd88","od-square-check-big-24":"bd9b6228352bd8cccda797d99bd24511","od-submenu-24":"161a8f49563000ba46ee35084f88a168","od-support-24":"d61f82117e2f57a9a45aa9ed4a72a302","od-user-24":"11f34927e95d178e76231fb027197b45","od-user-star-24":"e2f1fa7b99ee37742fd4839c783179df","od-wallet-24":"a7f8ef3136331760a0d672b2af8e7333","od-zap-24":"f6cb1b56f36d7e72907a16f0490159ff","od-40-case":"a79651233331c42a242490467e8b2c8c","od-40-eye":"168ac5f9465988c0a2679ac914896d23","od-40-gavel":"5a83b59e0a85d6c9a0e748a1628dfefb","od-40-hand-coins":"f0829be4b867ba70643a0c9569663688","od-40-library":"2adc2a7b1fc165c3edef891a7e6ac4e7","od-40-magazine":"32f336f2e534f253d94506b919977fc8","od-40-search-check":"5d65d02d0ac9659a7785a572884844cd","od-40-search":"5f67c56f45b01a55b88afd44c64a4831","od-40-shield-user":"bac211e7bec3729ed96228bf2bc7fc32","od-40-user":"4077d96f0cd3e6fa71131d8f30a9f0f5","od-40-zap":"0b692bea08538cccbc6e66e7755c6117"}
